import TextField, { TextFieldProps } from '../TextField/TextField';

const TextAreaField = ({ type, ...props }: TextFieldProps) => {
  return <TextField type="textarea" {...props} />;
};

export default TextAreaField;
